import React from 'react';
import InfoButton from './InfoButton';

export default function Title({ details, className }) {
  return (
    <div
      css={`
        font-size: ${details?.font_size || '1.2rem'};
        font-weight: ${details?.font_weight || '600'};
      `}
      className={`tw-flex ${className}`}
    >
      {details?.title}
      {details?.info?.length > 0 && <InfoButton details={details?.info} />}
    </div>
  );
}
